import type { FeatureFlag, FeatureFlagWithComplexTest } from './utils/featureFlags/types';

export const inspiringSearchPrototype: FeatureFlag = {
  name: 'inspiringSearchPrototype',
};

/** for development purposes only, do not use */
export const dummyFeatureFlag: FeatureFlagWithComplexTest<unknown> = {
  name: 'dummyFeatureFlag',
  test: {
    testId: 'dummyTestId',
    defaultGroup: 'default',
    featureCookieGroup: 'feature',
    getTestGroup: () => 'test',
  },
};
